import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';

import { SelectedCard, CardQuery, CardOptionQuery, BinNumberQuery, cardCheckActions } from '@awp/nac/card-check/api';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { isNullOrEmpty } from '@awp/core/utils';
import { ApiInsuranceType } from '@awp/quote/models';

@Component({
  selector: 'ap-card-quote-check',
  templateUrl: './card-quote-check.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardQuoteCheckComponent implements OnInit {

  showBinNotFound: boolean = false;
  showAlternativeBinFound: boolean = false;

  private _context: any;
  get context(): any {
    return this._context;
  }
  set context(value: any) {
    this._context = value;
    this.resetBin();
    this.changeDetectorRef.markForCheck();
  }

  constructor(
    public cardQuery: CardQuery,
    public cardOptionQuery: CardOptionQuery,
    public binQuery: BinNumberQuery,
    private store: Store<any>,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.binQuery.values
      .pipe(untilDestroyed(this))
      .subscribe(p => {
        this.showBinNotFound = (!isNullOrEmpty(p.binNumber) && p.binFound === false);
        this.showAlternativeBinFound = (!isNullOrEmpty(p.binNumber) && p.alternativeBin === true);
      });
  }

  ngOnDestroy() { }

  onCardSelected(card: SelectedCard): void {
    const selectedCard: SelectedCard = {
        ...card,
        clientId: this.context.theme.themeId
      };

    this.store.dispatch(new cardCheckActions.SelectCardTypeAction({ card: selectedCard, insuranceType: ApiInsuranceType.TravelInsurance }));
  }

  onBinSearch(bin: string): void {
    this.store.dispatch(new cardCheckActions.BinSearchAction(bin, ApiInsuranceType.TravelInsurance));
  }

  resetBin(): void {
    this.store.dispatch(new cardCheckActions.ResetBinSearch());
    this.showBinNotFound = false;
    this.showAlternativeBinFound = false;
  }
  
  onClearNoBinError(): void {
    this.showBinNotFound = false;
  }

  onClearAlternativeBinError(): void {
    this.showAlternativeBinFound = false;
  }
}
